import React from "react";
import styled from "styled-components";
import { CheckboxIcon } from "@sonder/ui/source/styled/fragments/CheckboxIcon";
import { GenericDropdownItem } from "@sonder/ui/source/styled/fragments/GenericDropdownItem";

const StyledCheckboxIcon = styled(CheckboxIcon)`
  margin-right: 1rem;
`;

interface CheckboxDropdownItemProps {
  checked?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const CheckboxDropdownItem = (props: CheckboxDropdownItemProps) => {
  const { checked = false, children, ...rest } = props;

  return (
    <GenericDropdownItem {...rest}>
      <StyledCheckboxIcon checked={checked} />
      {children}
    </GenericDropdownItem>
  );
};
